import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const goldClass =
  "btn-gold group inline-flex items-center gap-3 px-7 py-4 font-mono text-[11px] font-semibold uppercase tracking-[0.22em]";

const ghostClass = (dark) =>
  `group inline-flex items-center gap-3 border px-7 py-4 font-mono text-[11px] font-medium uppercase tracking-[0.22em] transition-colors duration-300 ${
    dark
      ? "border-accent/40 text-accent hover:border-accent hover:bg-accent/10"
      : "border-ink/25 text-ink hover:border-accent-dark hover:text-accent-dark"
  }`;

const Arrow = () => (
  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
);

export const PrimaryCTA = ({ children = "SCOPRI QUANTO SEI LIBERO DALLA TUA AZIENDA", to, href, testid = "cta-primary", className = "" }) => {
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={`${goldClass} ${className}`}>
        {children}
        <Arrow />
      </a>
    );
  }
  return (
    <Link to={to || "/contatti"} data-testid={testid} className={`${goldClass} ${className}`}>
      {children}
      <Arrow />
    </Link>
  );
};

export const GhostCTA = ({ children, to, href, dark = false, testid, className = "" }) => {
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testid} className={`${ghostClass(dark)} ${className}`}>
        {children}
        <Arrow />
      </a>
    );
  }
  return (
    <Link to={to} data-testid={testid} className={`${ghostClass(dark)} ${className}`}>
      {children}
      <Arrow />
    </Link>
  );
};
